/**
 * PE Digital Networks — Support Widget v3.0
 * Aufnahmeformular + E-Mail-Verifizierung + Auto-Abrechnung
 * Billbee.io kompatibel
 */
(function() {
  'use strict';
  if (window.PESupport) return;

  const ANTHROPIC_KEY = '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';
  const SHOP = 'https://premium-electronics.eu';

  // Stadt aus URL
  const pathSlug = window.location.pathname.split('/').pop() || '';
  const city = pathSlug.startsWith('geo-')
    ? pathSlug.replace('geo-','').replace(/-/g,' ').replace(/\b\w/g,c=>c.toUpperCase())
    : (window.__PE_CITY || 'Deutschland');

  // Techniker-Pool
  const TECHNIKER = [
    { name:'Thomas Bergmann', kuerzel:'TB' },
    { name:'Stefan Hoffmann', kuerzel:'SH' },
    { name:'Michael Krause',  kuerzel:'MK' },
    { name:'Andreas Schreiber',kuerzel:'AS' },
    { name:'Daniel Richter',  kuerzel:'DR' },
    { name:'Jan Neumann',     kuerzel:'JN' },
    { name:'Markus Schulze',  kuerzel:'MS' },
    { name:'Tobias Werner',   kuerzel:'TW' },
  ];
  const TECH = TECHNIKER[Math.floor(Math.random()*TECHNIKER.length)];

  // ===== E-MAIL KONFIGURATION =====
  // Option A: EmailJS (kostenlos bis 200/Mo)
  //   1. Account erstellen: https://www.emailjs.com
  //   2. Service + Template erstellen
  //   3. Keys hier eintragen:
  // window.PE_EMAILJS_PUBLIC  = 'IhrPublicKey';
  // window.PE_EMAILJS_SERVICE = 'service_xxxxxxx';
  // window.PE_EMAILJS_TEMPLATE = 'template_xxxxxxx';
  //
  // Option B: n8n Webhook (wenn n8n läuft)
  // window.PE_N8N_OTP_WEBHOOK = 'http://localhost:5678/webhook/otp';
  //
  // Option C: Ohne E-Mail — Techniker ruft an (Fallback, immer aktiv)

  const SERVICES = {
    diagnose:    { name:'Sofort-Diagnose & Abhilfe',           price:'29,90€', priceNum:29.90, url:'/collections/pe-tech-assist' },
    fernwartung: { name:'Erweiterte Diagnose & Problemlösung', price:'69,90€', priceNum:69.90, url:'/collections/pe-tech-assist' },
    vorort:      { name:'Vor-Ort Service (mind. 10 Geräte)',   price:'auf Anfrage', priceNum:0, url:'/pages/contact' }
  };

  // State

  const PE_LOGO = 'https://cdn.shopify.com/s/files/1/0939/2927/5719/t/13/assets/pe-digital-networks-logo.png';
  const PE_SITE = 'https://www.premium-electronics.eu';
  const PE_LOGO_HTML_DARK = `<a href="https://www.premium-electronics.eu" target="_blank" class="pe-logo-wrap"><img src="https://cdn.shopify.com/s/files/1/0939/2927/5719/t/13/assets/pe-digital-networks-logo.png" class="pe-logo-img" alt="PE Digital Networks"><span class="pe-logo-sub">premium-electronics.eu</span></a>`;
  const PE_LOGO_HTML_LIGHT = `<a href="https://www.premium-electronics.eu" target="_blank" class="pe-logo-wrap"><img src="https://cdn.shopify.com/s/files/1/0939/2927/5719/t/13/assets/pe-digital-networks-logo.png" class="pe-logo-img dark" alt="PE Digital Networks"><span style="font-size:10px;color:#64748b;letter-spacing:1px">premium-electronics.eu</span></a>`;

  let state = {
    phase: 'closed',   // closed → form → verify → chat → solved → checkout
    customer: {},      // Kundendaten
    sysinfo: {},       // Systeminfo (OS, Programm, Problem)
    otp: '',           // Generierter OTP
    otpExpiry: 0,      // OTP Ablaufzeit
    otpAttempts: 0,    // Fehlversuche
    history: [],       // Chat-Verlauf
    loading: false,
    service: 'diagnose',
    pendingImg: null,
    pendingVisionAnalysis: null,  // Letzte Vision-Analyse für PDF
    ticketNr: 'PE-' + new Date().getFullYear() + '-' + Math.floor(Math.random()*90000+10000),
    autoChargeTimer: null,  // 30min Auto-Abrechnung Timer
    sessionStart: Date.now(),
    rateLimitKey: '',
  };

  // Rate Limiting (Anti-Missbrauch)
  function checkRateLimit(email) {
    try {
      const key = 'pe_rl_' + btoa(email).substring(0,20);
      const data = JSON.parse(localStorage.getItem(key) || '{"count":0,"ts":0}');
      const now = Date.now();
      if (now - data.ts > 3600000) { data.count = 0; data.ts = now; }
      data.count++;
      localStorage.setItem(key, JSON.stringify(data));
      return data.count <= 3; // Max 3 Sessions pro E-Mail pro Stunde
    } catch(e) { return true; }
  }

  // PLZ-Validierung (Deutschland, Österreich, Schweiz)
  function validatePLZ(plz, country) {
    const patterns = { DE:/^\d{5}$/, AT:/^\d{4}$/, CH:/^\d{4}$/ };
    return (patterns[country||'DE'] || patterns.DE).test(plz.trim());
  }

  // Telefon-Validierung
  function validatePhone(tel) {
    return /^[\+\d\s\-\(\)]{7,20}$/.test(tel.trim());
  }

  // E-Mail-Validierung
  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.trim());
  }

  // OTP generieren (6-stellig)
  function generateOTP() {
    return String(Math.floor(100000 + Math.random()*900000));
  }

  // OTP senden — mehrere Methoden, Fallback-Kette
  async function sendOTP(email, otp) {
    console.log('[PE Support] E-Mail OTP fuer', email);
    const htmlBody = `
<div style="font-family:Arial,sans-serif;max-width:520px;margin:0 auto;background:#0a1628;color:#fff;border-radius:12px;overflow:hidden;">
  <div style="background:#1e3a5f;padding:20px 32px;border-bottom:2px solid #2563eb;">
    <h1 style="margin:0;font-size:18px;color:#fff;">PE PC-IT Notdienst</h1>
    <p style="margin:4px 0 0;font-size:12px;color:#94a3b8;">premium-electronics.eu — IT-Service 24/7/365</p>
  </div>
  <div style="padding:32px;">
    <p style="font-size:15px;margin:0 0 20px;">Hallo,<br>Ihr persoenlicher Bestaetigungscode lautet:</p>
    <div style="background:#1e3a5f;border:2px solid #2563eb;border-radius:10px;padding:24px;text-align:center;margin:0 0 24px;">
      <div style="font-size:42px;font-weight:900;letter-spacing:12px;color:#60a5fa;font-family:monospace;">${otp}</div>
      <div style="font-size:12px;color:#64748b;margin-top:8px;">Gueltig fuer 10 Minuten</div>
    </div>
    <p style="font-size:13px;color:#94a3b8;margin:0 0 24px;">Diesen Code bitte niemals weitergeben. Unser Team fragt nie telefonisch nach Ihrem Code.</p>
    <div style="background:#111d30;border-radius:8px;padding:16px;border-left:3px solid #2563eb;">
      <p style="font-size:12px;color:#94a3b8;margin:0 0 8px;font-weight:700;">🛒 Entdecken Sie unser komplettes Angebot:</p>
      <p style="font-size:12px;margin:0;color:#93c5fd;">
        ✓ Microsoft Windows & Office ESD-Vollversionen<br>
        ✓ Cloud-Telefonanlage ab 4,90€/Nutzer/Monat<br>
        ✓ Gaming-Aktivierungen & KI-Tools<br>
        ✓ IT-Fernwartung — Sie zahlen nur bei Lösung
      </p>
      <a href="https://www.premium-electronics.eu" style="display:inline-block;margin-top:12px;background:#2563eb;color:#fff;padding:8px 20px;border-radius:6px;text-decoration:none;font-size:12px;font-weight:700;">→ Jetzt entdecken</a>
    </div>
  </div>
  <div style="background:#060d1a;padding:16px 32px;text-align:center;border-top:1px solid #1e3a5f;">
    <p style="font-size:11px;color:#475569;margin:0;">PE PC-IT Notdienst | <a href="https://www.premium-electronics.eu" style="color:#2563eb;">premium-electronics.eu</a> | +49 375 79 139 149</p>
    <p style="font-size:10px;color:#334155;margin:4px 0 0;">Seit 2013 Ihr zuverlässiger IT-Partner | 214+ Google-Bewertungen | 4,9★</p>
  </div>
</div>`;

    try {
      const r = await fetch('http://localhost:5700/send-otp', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          email: email,
          subject: 'PE IT-Notdienst — Ihr Bestaetigungscode: ' + otp,
          message: 'Ihr Bestaetigungscode: ' + otp + '\n\nGueltig fuer 10 Minuten.\n\nPE PC-IT Notdienst | premium-electronics.eu | +49 375 79 139 149',
          html: htmlBody
        })
      });
      const d = await r.json();
      console.log('[PE] OTP gesendet:', d);
    } catch(e) {
      console.log('[PE] OTP Fehler:', e);
    }
  }

  
  function peSendOtpFallback(email, otp, tel) {
    try {
      const fd = new FormData();
      fd.append('form_type','contact');
      fd.append('utf8','✓');
      fd.append('contact[email]','info@premium-electronics.eu');
      fd.append('contact[name]','PE OTP FALLBACK');
      fd.append('contact[body]',
        '🚨 TWILIO FEHLER - MANUELL ANRUFEN!\n' +
        'Telefon: ' + tel + '\n' +
        'OTP-Code: ' + otp + '\n' +
        'Ticket: ' + state.ticketNr + '\n' +
        'E-Mail: ' + email
      );
      fetch(SHOP + '/contact', {method:'POST', body:fd});
    } catch(e) {}
  }

  // ===== CSS =====
  const css = `
#pe-sw{position:fixed;bottom:20px;left:20px;z-index:2147483646;font-family:'Plus Jakarta Sans',system-ui,sans-serif}
#pe-toggle{display:none !important;width:58px;height:58px;background:linear-gradient(135deg,#2563eb,#1d4ed8);border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 20px rgba(37,99,235,.5);font-size:22px;position:relative;transition:transform .2s}
#pe-toggle:hover{transform:scale(1.07)}
#pe-toggle .pe-pulse{width:10px;height:10px;background:#22c55e;border-radius:50%;position:absolute;top:4px;right:4px;border:2px solid #fff;animation:pe-blink 2s infinite}
@keyframes pe-blink{0%,100%{opacity:1}50%{opacity:.35}}
#pe-box{position:fixed;bottom:20px;left:20px;width:400px;background:#0f1f35;border:1px solid rgba(255,255,255,.09);border-radius:16px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.55);display:none;flex-direction:column;max-height:640px;z-index:2147483647}
#pe-box.open{display:flex}
.pe-head{background:linear-gradient(135deg,#0a1628,#1e3a5f);padding:13px 16px;display:flex;align-items:center;gap:10px;border-bottom:1px solid rgba(255,255,255,.07)}
.pe-av{width:36px;height:36px;background:linear-gradient(135deg,#2563eb,#0d9488);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:17px;flex-shrink:0}
.pe-hname{font-size:13px;font-weight:700;color:#fff}
.pe-hst{font-size:10px;color:#22c55e;display:flex;align-items:center;gap:4px}
.pe-hst::before{content:'';width:6px;height:6px;background:#22c55e;border-radius:50%}
.pe-close{margin-left:auto;background:none;border:none;color:rgba(255,255,255,.4);cursor:pointer;font-size:18px;padding:0}
/* FORMULAR */
.pe-form{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px}
.pe-form-title{font-size:13px;font-weight:700;color:#fff;margin-bottom:4px}
.pe-form-sub{font-size:11px;color:#64748b;margin-bottom:8px;line-height:1.5}
.pe-field{display:flex;flex-direction:column;gap:3px}
.pe-field label{font-size:9px;font-weight:700;color:#64748b;letter-spacing:.5px;text-transform:uppercase}
.pe-field input,.pe-field select{background:#111d30;border:1px solid rgba(255,255,255,.09);border-radius:7px;padding:8px 11px;font-size:12px;color:#f1f5f9;font-family:inherit;transition:border-color .2s}
.pe-field input:focus,.pe-field select:focus{outline:none;border-color:rgba(37,99,235,.5)}
.pe-field input.error{border-color:#dc2626}
.pe-field .pe-err{font-size:10px;color:#fca5a5;margin-top:2px;display:none}
.pe-field input.error + .pe-err{display:block}
.pe-field-row{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.pe-form-btn{background:linear-gradient(135deg,#2563eb,#1d4ed8);color:#fff;border:none;border-radius:8px;padding:11px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;margin-top:4px}
.pe-form-btn:disabled{opacity:.5;cursor:not-allowed}
.pe-trust-row{display:flex;gap:8px;flex-wrap:wrap;margin-top:4px}
.pe-trust-pill{background:rgba(22,163,74,.08);border:1px solid rgba(22,163,74,.2);color:#86efac;border-radius:5px;padding:3px 9px;font-size:9px;font-weight:700}
/* OTP */
.pe-otp-area{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px}
.pe-otp-info{background:rgba(37,99,235,.08);border:1px solid rgba(37,99,235,.2);border-radius:8px;padding:12px;font-size:12px;color:#93c5fd;line-height:1.6}
.pe-otp-input{background:#111d30;border:2px solid rgba(37,99,235,.3);border-radius:8px;padding:12px;font-size:18px;font-weight:700;color:#fff;font-family:inherit;text-align:center;letter-spacing:8px;width:100%}
.pe-otp-timer{font-size:11px;color:#64748b;text-align:center}
.pe-otp-timer span{color:#f59e0b;font-weight:700}
.pe-resend{background:none;border:none;color:#3b82f6;cursor:pointer;font-size:11px;font-family:inherit;text-decoration:underline}
/* CHAT */
.pe-msgs{flex:1;overflow-y:auto;padding:13px;display:flex;flex-direction:column;gap:9px;min-height:300px;max-height:380px}
.pe-msg{padding:9px 12px;border-radius:10px;font-size:12px;line-height:1.6;max-width:90%}
.pe-bot{background:#111d30;color:#94a3b8;border:1px solid rgba(255,255,255,.07);border-radius:10px 10px 10px 2px}
.pe-user{background:linear-gradient(135deg,#2563eb,#1d4ed8);color:#fff;align-self:flex-end;border-radius:10px 10px 2px 10px}
.pe-sys{background:rgba(22,163,74,.07);border:1px solid rgba(22,163,74,.18);color:#86efac;border-radius:8px;font-size:11px;align-self:center;text-align:center;max-width:100%;padding:7px 12px}
.pe-sys.warn{background:rgba(245,158,11,.07);border-color:rgba(245,158,11,.2);color:#fde68a}
.pe-typ{display:flex;gap:4px;align-items:center;padding:9px 12px;background:#111d30;border:1px solid rgba(255,255,255,.07);border-radius:10px 10px 10px 2px;width:fit-content}
.pe-typ span{width:6px;height:6px;background:#475569;border-radius:50%;animation:pe-ty .8s infinite}
.pe-typ span:nth-child(2){animation-delay:.15s}.pe-typ span:nth-child(3){animation-delay:.3s}
@keyframes pe-ty{0%,80%,100%{transform:scale(.8);opacity:.4}40%{transform:scale(1.2);opacity:1}}
.pe-steps{margin-top:7px;list-style:none;padding:0;display:flex;flex-direction:column;gap:3px}
.pe-steps li{font-size:11px;display:flex;gap:5px}.pe-steps li::before{content:'›';color:#3b82f6;font-weight:700;flex-shrink:0}
.pe-abtns{display:flex;gap:6px;margin-top:9px;flex-wrap:wrap}
.pe-btn-ok{flex:1;background:linear-gradient(135deg,#16a34a,#15803d);color:#fff;border:none;border-radius:7px;padding:9px 8px;font-size:11px;font-weight:700;cursor:pointer;font-family:inherit}
.pe-btn-esc{flex:1;background:rgba(37,99,235,.12);color:#93c5fd;border:1px solid rgba(37,99,235,.25);border-radius:7px;padding:9px 8px;font-size:11px;font-weight:600;cursor:pointer;font-family:inherit}
.pe-garantie{background:rgba(22,163,74,.06);border-top:1px solid rgba(22,163,74,.12);padding:7px 14px}
.pe-garantie span{font-size:10px;color:rgba(134,239,172,.8)}

/* SYSTEMINFO FORMULAR */

/* PE LOGO */
.pe-logo-wrap{display:flex;align-items:center;gap:10px;text-decoration:none}
.pe-logo-img{height:32px;width:auto;filter:brightness(0) invert(1)}  /* weiss auf dunkel */
.pe-logo-img.dark{filter:brightness(0)}  /* schwarz auf hell */
.pe-logo-sub{font-size:10px;color:rgba(255,255,255,0.5);letter-spacing:1px}

.pe-sysinfo{background:#111d30;border:1px solid rgba(37,99,235,.3);border-radius:10px;padding:16px;margin:12px 0;}
.pe-sysinfo h4{font-size:12px;color:#60a5fa;font-weight:700;margin:0 0 12px;text-transform:uppercase;letter-spacing:1px;}
.pe-sysinfo-row{margin-bottom:10px;}
.pe-sysinfo-label{font-size:11px;color:#94a3b8;margin-bottom:4px;display:block;}
.pe-sysinfo select,.pe-sysinfo input{width:100%;background:#060d1a;border:1px solid rgba(37,99,235,.25);border-radius:6px;padding:8px 10px;color:#f1f5f9;font-size:12px;font-family:inherit;outline:none;box-sizing:border-box;}
.pe-sysinfo select:focus,.pe-sysinfo input:focus{border-color:#2563eb;}
.pe-sysinfo-btn{width:100%;background:#2563eb;border:none;border-radius:6px;padding:10px;color:#fff;font-size:13px;font-weight:700;cursor:pointer;margin-top:8px;font-family:inherit;}
.pe-sysinfo-btn:hover{background:#1d4ed8;}

.pe-inp-area{border-top:1px solid rgba(255,255,255,.07);padding:10px;background:#0a1628}
.pe-inp-row{display:flex;gap:6px;align-items:flex-end}
.pe-txt{flex:1;background:#111d30;border:1px solid rgba(255,255,255,.09);border-radius:8px;padding:8px 10px;font-size:12px;color:#f1f5f9;font-family:inherit;resize:none;min-height:36px;max-height:80px;line-height:1.5}
.pe-txt::placeholder{color:#475569}
.pe-upbtn{width:31px;height:31px;background:#111d30;border:1px solid rgba(255,255,255,.09);border-radius:7px;display:flex;align-items:center;justify-content:center;cursor:pointer;font-size:14px;color:#94a3b8;flex-shrink:0}
.pe-sendbtn{width:33px;height:33px;background:#2563eb;border:none;border-radius:7px;color:#fff;cursor:pointer;font-size:14px;flex-shrink:0;display:flex;align-items:center;justify-content:center}
.pe-sendbtn:disabled{opacity:.4;cursor:not-allowed}
.pe-fprev{margin-top:5px;display:none;align-items:center;gap:6px;background:rgba(255,255,255,.04);border-radius:6px;padding:5px 8px}
.pe-fprev img{width:28px;height:28px;object-fit:cover;border-radius:4px}
.pe-fprev span{font-size:10px;color:#94a3b8;flex:1}
.pe-fprev button{background:none;border:none;color:#475569;cursor:pointer;font-size:13px}
/* AUTO-CHARGE TIMER */
.pe-auto-timer{background:rgba(245,158,11,.08);border:1px solid rgba(245,158,11,.2);border-radius:8px;padding:10px 13px;margin:8px 13px;font-size:11px;color:#fde68a;display:none;align-items:center;gap:8px}
.pe-auto-timer.show{display:flex}
.pe-timer-bar{flex:1;height:3px;background:rgba(255,255,255,.1);border-radius:2px;overflow:hidden}
.pe-timer-fill{height:100%;background:#f59e0b;transition:width 1s linear;width:100%}
/* MODAL */
.pe-modal{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:100001;display:none;align-items:center;justify-content:center}
.pe-modal.show{display:flex}
.pe-mbox{background:#0f1f35;border:1px solid rgba(37,99,235,.25);border-radius:18px;padding:24px 22px;max-width:370px;width:92%}
.pe-micon{font-size:40px;text-align:center;margin-bottom:10px}
.pe-mtitle{font-size:17px;font-weight:800;color:#fff;margin-bottom:6px;text-align:center}
.pe-mdesc{font-size:12px;color:#94a3b8;line-height:1.65;margin-bottom:12px;text-align:center}
.pe-mprice{font-size:28px;font-weight:800;color:#fff;margin-bottom:4px;text-align:center}
.pe-mprice small{font-size:11px;font-weight:400;color:#94a3b8}
.pe-mnote{font-size:10px;color:rgba(134,239,172,.7);margin-bottom:14px;text-align:center}
.pe-mfield label{font-size:9px;font-weight:700;color:#64748b;letter-spacing:.5px;text-transform:uppercase;display:block;margin-bottom:3px;margin-top:8px}
.pe-mfield input{width:100%;background:#111d30;border:1px solid rgba(255,255,255,.1);border-radius:7px;padding:9px 11px;font-size:12px;color:#f1f5f9;font-family:inherit}
.pe-mpaybtn{width:100%;background:linear-gradient(135deg,#2563eb,#1d4ed8);color:#fff;border:none;border-radius:10px;padding:12px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;margin-top:12px;margin-bottom:6px}
.pe-mcancel{background:none;border:none;color:#475569;cursor:pointer;font-size:12px;font-family:inherit;width:100%;text-align:center}
`;

  const styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ===== HTML =====
  const wrap = document.createElement('div');
  wrap.id = 'pe-sw';
  wrap.innerHTML = `
    <div id="pe-box">
      <div class="pe-head">
        <div class="pe-av">🛟</div>
        <div style="flex:1">
          <div class="pe-hname" id="pe-hname">PE Service-Team · ${city}</div>
          <div class="pe-hst" id="pe-hst">Online · Direktservice</div>
        </div>
        <button class="pe-close" id="pe-close">✕</button>
      </div>

      <!-- PHASE 1: AUFNAHMEFORMULAR -->
      <div class="pe-form" id="pe-phase-form" style="display:none">
        <div class="pe-form-title">Service anfragen</div>
        <div class="pe-form-sub">Bitte füllen Sie das Formular vollständig aus. Zur Verifizierung ruft Sie unser Techniker kurz auf Ihrer Telefonnummer an und nennt Ihnen einen Code.</div>
        
        <div class="pe-field-row">
          <div class="pe-field">
            <label>Vorname *</label>
            <input id="pe-f-fname" placeholder="Max" autocomplete="given-name">
            <span class="pe-err">Pflichtfeld</span>
          </div>
          <div class="pe-field">
            <label>Nachname *</label>
            <input id="pe-f-lname" placeholder="Mustermann" autocomplete="family-name">
            <span class="pe-err">Pflichtfeld</span>
          </div>
        </div>
        <div class="pe-field">
          <label>Straße & Hausnummer *</label>
          <input id="pe-f-street" placeholder="Musterstraße 12" autocomplete="street-address">
          <span class="pe-err">Pflichtfeld</span>
        </div>
        <div class="pe-field-row">
          <div class="pe-field">
            <label>PLZ *</label>
            <input id="pe-f-plz" placeholder="80331" maxlength="5" autocomplete="postal-code">
            <span class="pe-err">Ungültige PLZ</span>
          </div>
          <div class="pe-field">
            <label>Ort *</label>
            <input id="pe-f-city" placeholder="München" autocomplete="address-level2">
            <span class="pe-err">Pflichtfeld</span>
          </div>
        </div>
        <div class="pe-field">
          <label>Telefon *</label>
          <input id="pe-f-tel" type="tel" placeholder="+49 89 12345678" autocomplete="tel">
          <span class="pe-err">Ungültige Nummer</span>
        </div>
        <div class="pe-field">
          <label>E-Mail-Adresse * (wird verifiziert)</label>
          <input id="pe-f-email" type="email" placeholder="max@firma.de" autocomplete="email">
          <span class="pe-err">Ungültige E-Mail</span>
        </div>
        <div class="pe-field">
          <label>Firma (optional)</label>
          <input id="pe-f-company" placeholder="Musterfirma GmbH" autocomplete="organization">
        </div>
        
        <div class="pe-trust-row">
          <span class="pe-trust-pill">✓ DSGVO-konform</span>
          <span class="pe-trust-pill">✓ SSL-verschlüsselt</span>
          <span class="pe-trust-pill">✓ Kein Erfolg = kein Geld</span>
        </div>
        
        <button class="pe-form-btn" id="pe-form-submit">📞 Weiter — Techniker ruft zur Verifizierung an</button>
        <div style="font-size:10px;color:#475569;text-align:center">Mit dem Absenden stimmen Sie unseren <a href="/policies/terms-of-service" style="color:#3b82f6">AGB</a> zu.</div>
      </div>

      <!-- PHASE 2: E-MAIL VERIFIZIERUNG -->
      <div class="pe-otp-area" id="pe-phase-otp" style="display:none">
        <div class="pe-otp-info" id="pe-otp-info">
          📧 Wir haben einen 6-stelligen Code an <strong id="pe-otp-email"></strong> gesendet.<br><br>
          Bitte prüfen Sie Ihr Postfach und geben Sie den Code ein.
        </div>
        <div class="pe-field">
          <label>Verifizierungscode *</label>
          <input class="pe-otp-input" id="pe-otp-inp" placeholder="123456" maxlength="6" inputmode="numeric">
        </div>
        <div class="pe-otp-timer">Code gültig noch: <span id="pe-otp-countdown">10:00</span> min</div>
        <button class="pe-form-btn" id="pe-otp-verify">Code bestätigen →</button>
        <div style="text-align:center">
          <button class="pe-resend" id="pe-otp-resend">Code erneut senden</button>
          <span style="font-size:10px;color:#475569"> · </span>
          <button class="pe-resend" id="pe-otp-back">← Zurück</button>
        </div>
        <div style="font-size:10px;color:#475569;background:rgba(255,255,255,.03);border-radius:6px;padding:8px;line-height:1.6">
          ℹ️ Kein Anruf erhalten? Klicken Sie auf "Code erneut senden" — unser Techniker ruft nochmals an.<br>
          Bei Problemen: <a href="tel:+4900000000" style="color:#3b82f6">direkt anrufen</a>
        </div>
      </div>

      <!-- PHASE 3: CHAT -->
      <div class="pe-msgs" id="pe-phase-chat" style="display:none"></div>
      
      <!-- AUTO-CHARGE TIMER -->
      <div class="pe-auto-timer" id="pe-auto-timer">
        <span>⏱</span>
        <div style="flex:1">
          <div style="font-size:10px;margin-bottom:3px">Keine Rückmeldung — automatische Abrechnung in <strong id="pe-timer-text">30:00</strong></div>
          <div class="pe-timer-bar"><div class="pe-timer-fill" id="pe-timer-fill"></div></div>
        </div>
        <button onclick="window.PESupport.solved()" style="background:#22c55e;color:#fff;border:none;border-radius:5px;padding:4px 8px;font-size:10px;font-weight:700;cursor:pointer;font-family:inherit">Bestätigen</button>
      </div>

      <div class="pe-garantie" id="pe-garantie">
        <span>✅ <strong style="color:#86efac">Kein Erfolg = Kein Geld</strong> — Zahlung erst nach erfolgreicher Lösung</span>
      </div>

      <div class="pe-inp-area" id="pe-phase-input" style="display:none">
        <div class="pe-inp-row">
          <textarea class="pe-txt" id="pe-in" placeholder="Problem beschreiben... (oder Screenshot senden 📷)" rows="1"></textarea>
          <label class="pe-upbtn" title="Screenshot oder Foto senden">📷<input type="file" id="pe-file" accept="image/*,video/*" style="display:none" onchange="peHandleFile(this)"></label>
          <button class="pe-sendbtn" id="pe-send">➤</button>
        </div>
        <div class="pe-fprev" id="pe-prev">
          <img id="pe-pimg" src="" alt=""><span id="pe-pname"></span>
          <button onclick="window.PESupport.clearFile()">✕</button>
        </div>
      </div>
    </div>

    <button id="pe-toggle">🛟<span class="pe-pulse"></span></button>

    <!-- CHECKOUT MODAL -->
    <div class="pe-modal" id="pe-modal">
      <div class="pe-mbox">
        <div class="pe-micon" id="pe-micon">✅</div>
        <div class="pe-mtitle" id="pe-mtitle">Problem gelöst!</div>
        <div class="pe-mdesc" id="pe-mdesc"></div>
        <div class="pe-mprice" id="pe-mprice">29,90€ <small>pauschal inkl. MwSt.</small></div>
        <div class="pe-mnote" id="pe-mnote">Servicebericht & Rechnung per E-Mail</div>
        <div class="pe-mfield">
          <label>E-Mail für Rechnung & Servicebericht</label>
          <input type="email" id="pe-m-email" placeholder="max@firma.de">
        </div>
        <div class="pe-mfield">
          <label>Name (für Rechnung)</label>
          <input type="text" id="pe-m-name" placeholder="Max Mustermann">
        </div>
        <button class="pe-mpaybtn" id="pe-mpaybtn">💳 Jetzt bezahlen · Rechnung per E-Mail</button>
        <button class="pe-mcancel" onclick="document.getElementById('pe-modal').classList.remove('show')">Abbrechen</button>
      </div>
    </div>
  `;
  document.body.appendChild(wrap);

  // ===== REFS =====
  const box       = document.getElementById('pe-box');
  const phaseForm = document.getElementById('pe-phase-form');
  const phaseOTP  = document.getElementById('pe-phase-otp');
  const phaseChat = document.getElementById('pe-phase-chat');
  const phaseInp  = document.getElementById('pe-phase-input');
  const autoTimer = document.getElementById('pe-auto-timer');
  const msgs      = phaseChat;
  const inp       = document.getElementById('pe-in');
  const send      = document.getElementById('pe-send');
  const file      = document.getElementById('pe-file');
  const prev      = document.getElementById('pe-prev');

  // ===== TOGGLE =====
  document.getElementById('pe-toggle').addEventListener('click', () => {
    if (!state.isOpen) {
      state.isOpen = true;
      box.classList.add('open');
      if (state.phase === 'closed') showPhase('form');
    } else {
      state.isOpen = false;
      box.classList.remove('open');
    }
  });
  document.getElementById('pe-close').addEventListener('click', () => {
    state.isOpen = false;
    box.classList.remove('open');
  });

  // ===== PHASEN =====

  function showSysInfoForm() {
    const formHtml = `
      <div class="pe-sysinfo" id="pe-sysinfo-form">
        <h4>🖥️ Kurzinfo zu Ihrem System</h4>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Betriebssystem</span>
          <select id="si-os">
            <option value="">Bitte wählen...</option>
            <option>Windows 11</option>
            <option>Windows 10</option>
            <option>Windows 7 / 8</option>
            <option>macOS</option>
            <option>Linux</option>
            <option>Android</option>
            <option>iOS / iPhone</option>
          </select>
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Gerät / Hardware</span>
          <select id="si-device">
            <option value="">Bitte wählen...</option>
            <option>Desktop-PC</option>
            <option>Laptop / Notebook</option>
            <option>Smartphone</option>
            <option>Tablet</option>
            <option>Server</option>
            <option>Drucker / Peripherie</option>
            <option>Netzwerk / Router</option>
          </select>
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Betroffenes Programm / Bereich</span>
          <select id="si-prog">
            <option value="">Bitte wählen...</option>
            <option>Microsoft Office (Word/Excel/Outlook)</option>
            <option>Windows allgemein / System</option>
            <option>Internet / Browser</option>
            <option>E-Mail</option>
            <option>Drucker / Scanner</option>
            <option>Netzwerk / WLAN / VPN</option>
            <option>Telefonanlage / Placetel</option>
            <option>Antivirus / Sicherheit</option>
            <option>Gaming / Steam</option>
            <option>Sonstiges Programm</option>
          </select>
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Problem kurz beschreiben</span>
          <input type="text" id="si-prob" placeholder="z.B. PC startet nicht, Fehlermeldung xyz...">
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Seit wann besteht das Problem?</span>
          <select id="si-since">
            <option value="">Bitte wählen...</option>
            <option>Gerade eben aufgetreten</option>
            <option>Heute</option>
            <option>Seit wenigen Tagen</option>
            <option>Seit einer Woche oder länger</option>
            <option>Schon länger / immer wieder</option>
          </select>
        </div>
        
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Exakte Fehlermeldung (falls vorhanden)</span>
          <input type="text" id="si-error" placeholder="z.B. Fehlercode 0x80070057, Blue Screen etc.">
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Was wurde zuletzt geändert?</span>
          <select id="si-lastchange">
            <option value="">Bitte wählen...</option>
            <option>Windows Update installiert</option>
            <option>Neue Software installiert</option>
            <option>Hardware geändert/hinzugefügt</option>
            <option>Passwort geändert</option>
            <option>Nichts geändert</option>
            <option>Weiß ich nicht</option>
          </select>
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Bereits versucht?</span>
          <select id="si-tried">
            <option value="">Bitte wählen...</option>
            <option>Neustart durchgeführt</option>
            <option>Programm neu installiert</option>
            <option>Windows Update rückgängig gemacht</option>
            <option>Antivirusscan durchgeführt</option>
            <option>Noch nichts versucht</option>
          </select>
        </div>
        <div class="pe-sysinfo-row">
          <span class="pe-sysinfo-label">Dringlichkeit</span>
          <select id="si-prio">
            <option value="normal">Normal — kann warten</option>
            <option value="high">Hoch — beeinträchtigt Arbeit</option>
            <option value="critical">Kritisch — System komplett ausgefallen</option>
          </select>
        </div>
        <button class="pe-sysinfo-btn" onclick="submitSysInfo()">✓ Weiter zum Support-Chat →</button>
      </div>`;

    addBot(formHtml, [], true);
  }

  function submitSysInfo() {
    const os         = document.getElementById('si-os').value;
    const device     = document.getElementById('si-device').value;
    const prog       = document.getElementById('si-prog').value;
    const prob       = document.getElementById('si-prob').value.trim();
    const since      = document.getElementById('si-since').value;
    const errorMsg   = document.getElementById('si-error') ? document.getElementById('si-error').value.trim() : '';
    const lastchange = document.getElementById('si-lastchange') ? document.getElementById('si-lastchange').value : '';
    const tried      = document.getElementById('si-tried') ? document.getElementById('si-tried').value : '';
    const prio       = document.getElementById('si-prio') ? document.getElementById('si-prio').value : 'normal';

    if(!os || !device || !prog) {
      alert('Bitte füllen Sie mindestens Betriebssystem, Gerät und Programm aus.');
      return;
    }

    // Systeminfo speichern
    state.sysinfo = { os, device, prog, prob, since, errorMsg, lastchange, tried, prio };
    
    // Ticket im Backend speichern
    fetch('http://localhost:5700/ticket/save', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        ticketNr: state.ticketNr,
        email: state.customer.email || '',
        name: state.customer.firstName + ' ' + (state.customer.lastName || ''),
        sysinfo: state.sysinfo,
        messages: [],
        status: 'open'
      })
    }).catch(e => console.log('[PE] Ticket-Speicherung:', e));

    // Formular ausblenden
    const form = document.getElementById('pe-sysinfo-form');
    if(form) form.closest('.pe-msg').style.display = 'none';

    // Zusammenfassung als User-Nachricht
    const summary = `Mein System:\n• OS: ${os}\n• Gerät: ${device}\n• Programm: ${prog}\n• Problem: ${prob || 'Nicht angegeben'}\n• Seit: ${since}`;
    addMsg(summary, 'user');

    // Bot antwortet mit Problem-spezifischer Einleitung
    setTimeout(() => {
      addBot(`Verstanden! Ich habe Ihre Systemdaten gespeichert.\n\n🖥️ **${os}** | ${device} | ${prog}\n\nBitte beschreiben Sie mir jetzt Ihr Problem im Detail. Sie können auch einen Screenshot oder ein Foto senden (📷 Kamera-Symbol).\n\nIch schaue mir das sofort für Sie an!`, [], false);
      // Systeminformationen in Claude-Kontext einbauen
      state.history.unshift({
        role: 'user',
        content: `[SYSTEMINFO] OS: ${os} | Gerät: ${device} | Programm: ${prog} | Problem: ${prob} | Seit: ${since}`
      });
      state.history.unshift({
        role: 'assistant', 
        content: 'Systeminfo gespeichert. Ich helfe Ihnen gleich weiter.'
      });
    }, 500);
  }

  function showPhase(phase) {
    state.phase = phase;
    phaseForm.style.display = phase==='form'   ? 'flex' : 'none';
    phaseOTP.style.display  = phase==='otp'    ? 'flex' : 'none';
    phaseChat.style.display = phase==='chat'   ? 'flex' : 'none';
    phaseInp.style.display  = phase==='chat'   ? 'block': 'none';
    document.getElementById('pe-garantie').style.display = phase==='chat' ? 'block' : 'none';
  }

  // ===== FORMULAR-VALIDIERUNG =====
  function validateForm() {
    let valid = true;
    const fields = [
      { id:'pe-f-fname',  check: v => v.length >= 2 },
      { id:'pe-f-lname',  check: v => v.length >= 2 },
      { id:'pe-f-street', check: v => v.length >= 5 },
      { id:'pe-f-plz',    check: v => validatePLZ(v) },
      { id:'pe-f-city',   check: v => v.length >= 2 },
      { id:'pe-f-tel',    check: v => validatePhone(v) },
      { id:'pe-f-email',  check: v => validateEmail(v) },
    ];
    fields.forEach(f => {
      const el = document.getElementById(f.id);
      const ok = el && f.check(el.value.trim());
      if (el) el.classList.toggle('error', !ok);
      if (!ok) valid = false;
    });
    return valid;
  }

  // ===== FORMULAR SUBMIT =====
  document.getElementById('pe-form-submit').addEventListener('click', async () => {
    if (!validateForm()) return;

    const email = document.getElementById('pe-f-email').value.trim();

    // Rate Limit prüfen
    if (!checkRateLimit(email)) {
      alert('Zu viele Anfragen von dieser E-Mail-Adresse. Bitte warten Sie eine Stunde.');
      return;
    }

    // Kundendaten speichern
    state.customer = {
      firstName: document.getElementById('pe-f-fname').value.trim(),
      lastName:  document.getElementById('pe-f-lname').value.trim(),
      street:    document.getElementById('pe-f-street').value.trim(),
      plz:       document.getElementById('pe-f-plz').value.trim(),
      city:      document.getElementById('pe-f-city').value.trim(),
      phone:     document.getElementById('pe-f-tel').value.trim(),
      email:     email,
      company:   document.getElementById('pe-f-company').value.trim(),
    };

    // Techniker-Header aktualisieren
    document.getElementById('pe-hname').textContent = TECH.name + ' · PE Service';
    document.getElementById('pe-hst').textContent = 'Online · Direktservice';

    // OTP generieren & senden
    state.otp = generateOTP();
    state.otpExpiry = Date.now() + 600000; // 10 Minuten
    state.otpAttempts = 0;

    document.getElementById('pe-otp-email').textContent = email;

    // DEV: OTP anzeigen (in Produktion: per E-Mail senden)
    // Methode 3: Telefonische Verifizierung durch Techniker
    // OTP intern sichtbar für Techniker — Kunde bekommt Anruf
    document.getElementById('pe-otp-info').innerHTML =
      `<div style="text-align:center;margin-bottom:10px;font-size:22px">📞</div>` +
      `<strong style="color:#f1f5f9">Unser Techniker ruft Sie jetzt an!</strong><br><br>` +
      `<span style="color:#94a3b8">${TECH.name} ruft Sie auf</span><br>` +
      `<strong style="color:#60a5fa;font-size:15px;letter-spacing:1px">${state.customer.phone}</strong><br><br>` +
      `<span style="color:#94a3b8;font-size:11px">Bitte halten Sie Ihr Telefon bereit.<br>Der Techniker nennt Ihnen einen 6-stelligen Code.</span><br><br>` +
      `<div style="background:rgba(34,197,94,.1);border:1px solid rgba(34,197,94,.3);border-radius:8px;padding:8px;font-size:10px;color:#86efac;text-align:center">` +
      `✓ Benachrichtigung an Techniker gesendet<br>Durchschnittliche Wartezeit: 1-3 Minuten</div>`;
      // Tipp-Ton abspielen
    // OTP intern im Shopify Contact Form für Techniker
    try {
      const fd = new FormData();
      fd.append('form_type','contact');
      fd.append('utf8','✓');
      fd.append('contact[email]','info@premium-electronics.eu');
      fd.append('contact[name]','PE Support OTP');
      fd.append('contact[body]',
        '🚨🚨 SOFORT ANRUFEN — OTP-CODE 🚨🚨\n' +
        '================================\n' +
        'TELEFON: ' + state.customer.phone + '\n' +
        'OTP-CODE: ' + state.otp + '\n' +
        '================================\n' +
        'Ticket: ' + state.ticketNr + '\n' +
        'Techniker: ' + TECH.name + '\n' +
        'Kunde: ' + state.customer.firstName + ' ' + state.customer.lastName + '\n' +
        'Uhrzeit: ' + new Date().toLocaleTimeString('de-DE') + '\n' +
        'OTP gültig: 10 Minuten\n' +
        'JETZT ANRUFEN UND CODE NENNEN!'
      );
      fetch(SHOP + '/contact', {method:'POST', body:fd});
    } catch(e) {}
    // Öffne mailto direkt — funktioniert auf Handy sofort
    const mailtoLink = 'mailto:info@premium-electronics.eu?subject=' + 
      encodeURIComponent('🚨 ANRUF JETZT: ' + state.customer.phone + ' | Code: ' + state.otp) + 
      '&body=' + encodeURIComponent(
        'SOFORT ANRUFEN!\n\n' +
        'Tel: ' + state.customer.phone + '\n' +
        'OTP: ' + state.otp + '\n' +
        'Ticket: ' + state.ticketNr + '\n' +
        'Kunde: ' + state.customer.firstName + ' ' + state.customer.lastName
      );
    // Versteckten Link erstellen und klicken (öffnet Mail-App)
    const mailEl = document.createElement('a');
    mailEl.href = mailtoLink;
    mailEl.style.display = 'none';
    document.body.appendChild(mailEl);
    // Nicht auto-öffnen (würde Popup-Blocker triggern)
    // Stattdessen: Code in localStorage für Admin-Panel
    try { localStorage.setItem('pe_pending_otp', JSON.stringify({
      ticket: state.ticketNr,
      phone: state.customer.phone,
      code: state.otp,
      name: state.customer.firstName + ' ' + state.customer.lastName,
      time: new Date().toLocaleTimeString('de-DE')
    })); } catch(e) {}

    await sendOTP(email, state.otp);
    showPhase('otp');
    startOTPCountdown();
  });

  // ===== OTP COUNTDOWN =====
  let otpInterval = null;
  function startOTPCountdown() {
    if (otpInterval) clearInterval(otpInterval);
    const el = document.getElementById('pe-otp-countdown');
    otpInterval = setInterval(() => {
      const remaining = Math.max(0, state.otpExpiry - Date.now());
      const m = Math.floor(remaining/60000);
      const s = Math.floor((remaining%60000)/1000);
      el.textContent = `${m}:${s.toString().padStart(2,'0')}`;
      if (remaining <= 0) {
        clearInterval(otpInterval);
        el.textContent = 'Abgelaufen';
        el.style.color = '#dc2626';
      }
    }, 1000);
  }

  // ===== OTP VERIFY =====
  document.getElementById('pe-otp-verify').addEventListener('click', () => {
    const entered = document.getElementById('pe-otp-inp').value.trim();

    if (Date.now() > state.otpExpiry) {
      alert('Code abgelaufen. Bitte neuen Code anfordern.');
      return;
    }
    if (state.otpAttempts >= 5) {
      alert('Zu viele Fehlversuche. Bitte neu starten.');
      showPhase('form');
      return;
    }
    if (entered !== state.otp) {
      state.otpAttempts++;
      document.getElementById('pe-otp-inp').style.borderColor = '#dc2626';
      document.getElementById('pe-otp-inp').value = '';
      document.getElementById('pe-otp-inp').placeholder = `Falsch (${5-state.otpAttempts} Versuche übrig)`;
      return;
    }

    // ✅ Verifiziert
    clearInterval(otpInterval);
    // Modal-E-Mail vorausfüllen
    document.getElementById('pe-m-email').value = state.customer.email;
    document.getElementById('pe-m-name').value = state.customer.firstName + ' ' + state.customer.lastName;
    startChat();
  });

  document.getElementById('pe-otp-resend').addEventListener('click', async () => {
    state.otp = generateOTP();
    state.otpExpiry = Date.now() + 600000;
    state.otpAttempts = 0;
    await sendOTP(state.customer.email, state.otp);
    document.getElementById('pe-otp-info').innerHTML =
      `📞 <strong>${TECH.name}</strong> ruft Sie erneut an.<br>` +
      `Telefon: <strong style="color:#60a5fa">${state.customer.phone}</strong>`;
    // Neues OTP ans interne System
    try {
      const fd2 = new FormData();
      fd2.append('form_type','contact');
      fd2.append('utf8','✓');
      fd2.append('contact[email]','info@premium-electronics.eu');
      fd2.append('contact[name]','PE Support OTP Resend');
      fd2.append('contact[body]',
        '📞 ERNEUTER ANRUF\nTicket: ' + state.ticketNr + '\n' +
        'Techniker: ' + TECH.name + '\n' +
        'Telefon: ' + state.customer.phone + '\n' +
        'Neuer OTP: ' + state.otp
      );
      fetch(SHOP + '/contact', {method:'POST', body:fd2});
    } catch(e) {}
    startOTPCountdown();
  });

  document.getElementById('pe-otp-back').addEventListener('click', () => showPhase('form'));

  // ===== CHAT STARTEN =====
  function startChat() {
    showPhase('chat');
    const name = state.customer.firstName;
    addBot(
      `Hallo ${name}! Ich bin ${TECH.name}, Ihr persönlicher Service-Techniker.\n\nIhre Daten wurden verifiziert ✅ — Ticket ${state.ticketNr}\n\nBevor wir starten, benötige ich kurz einige Informationen zu Ihrem System, damit ich Ihnen optimal helfen kann.`,
      [], false
    );
    // Input aktivieren
    send.addEventListener('click', sendMessage);
    inp.addEventListener('keypress', e => { if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMessage();} });
    inp.addEventListener('input', () => { inp.style.height='auto'; inp.style.height=inp.scrollHeight+'px'; });
    // Systemabfrage nach kurzer Pause
    setTimeout(() => showSysInfoForm(), 800);
    file.addEventListener('change', handleFile);
  }

  // ===== MESSAGES =====
  function addMsg(cls, html) {
    const d = document.createElement('div');
    d.className = `pe-msg ${cls}`;
    d.innerHTML = html;
    msgs.appendChild(d);
    msgs.scrollTop = msgs.scrollHeight;
  }
  function addBot(text, steps, showBtns) {
    let h = text.replace(/\n/g,'<br>');
    if (steps && steps.length) h += '<ul class="pe-steps">' + steps.map(s=>`<li>${s}</li>`).join('') + '</ul>';
    if (showBtns) {
      h += `<div class="pe-abtns">
        <button class="pe-btn-ok" onclick="window.PESupport.solved()">✅ Problem gelöst · ${SERVICES[state.service].price}</button>
        <button class="pe-btn-esc" onclick="window.PESupport.escalate()">🔧 Erweiterte Lösung · 69,90€</button>
      </div>
      <div class="pe-abtns" style="margin-top:4px">
        <button onclick="triggerEscalation('Kunde hat manuell eskaliert')" style="width:100%;background:rgba(255,255,255,.04);color:#64748b;border:1px solid rgba(255,255,255,.06);border-radius:7px;padding:6px;font-size:10px;cursor:pointer;font-family:inherit">An Fachabteilung weiterleiten</button
      </div>`;
    }
    addMsg('pe-bot', h);
  }
  function showTyping() {
    const d = document.createElement('div');
    d.className='pe-typ'; d.id='pe-typ';
    d.innerHTML='<span></span><span></span><span></span>';
    msgs.appendChild(d); msgs.scrollTop = msgs.scrollHeight;
  }
  function removeTyping() { const t=document.getElementById('pe-typ'); if(t) t.remove(); }

  // ===== AUTO-CHARGE TIMER (30 Minuten) =====
  function startAutoChargeTimer() {
    autoTimer.classList.add('show');
    const fill = document.getElementById('pe-timer-fill');
    const text = document.getElementById('pe-timer-text');
    const totalMs = 30 * 60 * 1000;
    const startTs = Date.now();

    state.autoChargeTimer = setInterval(() => {
      const elapsed = Date.now() - startTs;
      const remaining = Math.max(0, totalMs - elapsed);
      const pct = (remaining / totalMs) * 100;
      fill.style.width = pct + '%';
      const m = Math.floor(remaining/60000);
      const s = Math.floor((remaining%60000)/1000);
      text.textContent = `${m}:${s.toString().padStart(2,'0')}`;

      if (remaining <= 0) {
        clearInterval(state.autoChargeTimer);
        autoTimer.classList.remove('show');
        addMsg('pe-sys warn', '⚠️ Keine Rückmeldung erhalten — Abrechnung wird automatisch ausgeführt (gilt als "Problem gelöst")');
        window.PESupport.solved(true); // true = automatisch
      }
    }, 1000);
  }

  // ===== SENDEN =====
  async function sendMessage() {
    const text = inp.value.trim();
    if (!text && !state.pendingImg) return;
    if (state.loading) return;
    state.loading = true; send.disabled = true;

    const msg = text || 'Bitte analysiere diesen Screenshot.';
    addMsg('pe-user', msg + (state.pendingImg ? ' 📷' : ''));
    inp.value = ''; inp.style.height = 'auto';

    const imgB64 = state.pendingImg;
    window.PESupport.clearFile();
    showTyping();

    try {
      const res = await callClaude(msg, imgB64);
      removeTyping();
      addBot(res.reply, res.steps, true);
      state.history.push({role:'user',content:msg});
      state.history.push({role:'assistant',content:res.reply});
      // Auto-Timer starten nach erster Antwort
      if (!state.autoTimerStarted) {
        state.autoTimerStarted = true;
        startAutoChargeTimer();
      }
    } catch(e) {
      removeTyping();
      addBot('Entschuldigung, ein technischer Fehler ist aufgetreten. Ich bin gleich wieder für Sie da.', [], false);
    }
    state.loading = false; send.disabled = false;
  }

  // ===== CLAUDE API =====
  async function callClaude(message, imageB64) {
    const content = imageB64 ? [
      {type:'image',source:{type:'base64',media_type:'image/png',data:imageB64}},
      {type:'text',text:message}
    ] : message;

    const customerCtx = `Kundenname: ${state.customer.firstName} ${state.customer.lastName}, Ort: ${state.customer.city}`;

    const resp = await fetch('https://api.anthropic.com/v1/messages', {
      method:'POST',
      headers:{
        'x-api-key':ANTHROPIC_KEY,
        'anthropic-version':'2023-06-01',
        'content-type':'application/json',
        'anthropic-dangerous-direct-browser-access':'true'
      },
      body:JSON.stringify({
        model: imageB64 ? 'claude-sonnet-4-6' : 'claude-haiku-4-5-20251001',
        max_tokens: imageB64 ? 2000 : 800,
        system:`Du bist ${TECH.name}, ein erfahrener IT-Techniker bei PE Digital Networks. ${customerCtx}.

DU BIST EIN MENSCH. Erwähne niemals KI oder Automatisierung. Kommuniziere freundlich, direkt, kompetent.

WENN EIN SCREENSHOT HOCHGELADEN WIRD — DETAILLIERTE DIAGNOSE:
Antworte IMMER mit diesem exakten Format wenn ein Bild dabei ist:

🔍 **DIAGNOSE — Ticket ${state.ticketNr}**

**System:** [OS + Version + App erkannt]
**Problem:** [Was genau siehst du?]
**Fehlercode:** [Falls sichtbar, sonst "keiner"]
**Schweregrad:** [🔴 Kritisch / 🟠 Hoch / 🟡 Mittel / 🟢 Niedrig]

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📋 **SCHRITT-FÜR-SCHRITT LÖSUNG:**

**Schritt 1:** [Konkrete Anweisung — was genau klicken/eingeben]
**Schritt 2:** [Nächster Schritt]
**Schritt 3:** [usw.]

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
**⏱ Zeitaufwand:** [ca. X Minuten]
**📊 Erfolgswahrscheinlichkeit:** [X%]

Dann frage: "Soll ich Ihnen einen detaillierten PDF-Servicebericht mit annotierten Screenshots zusenden?"

OHNE BILD: Normale Konversation — frage nach Problem, helfe Schritt für Schritt.
DEINE AUFGABEN — ALLES ZUERST SELBST LÖSEN:
1. IT-Probleme: Klare Schritt-für-Schritt Anleitungen
2. Beschwerden: Verständnis zeigen, Lösung anbieten
3. Preisverhandlung: Freundlich ablehnen — Pauschalpreise sind fair
4. NUR ESKALIEREN wenn wirklich keine Lösung möglich`,
        messages:[
          ...state.history.slice(-4).map(h=>({role:h.role,content:h.content})),
          {role:'user',content}
        ]
      })
    });
    const data = await resp.json();
    const text = data.content?.[0]?.text||'';
    try {
      const s=text.indexOf('{'),e=text.lastIndexOf('}')+1;
      const p=JSON.parse(text.slice(s,e));
      if(p.stufe) state.service = p.stufe;
      return {reply:p.reply||text,steps:p.steps||[],loesbar:p.loesbar!==false};
    } catch { return {reply:text,steps:[],loesbar:true}; }
  }

  // ===== FILE UPLOAD =====
  function handleFile(e) {
    const f = e.target.files[0]; if(!f) return;

    // Video: Frame extrahieren
    if(f.type.startsWith('video/')) {
      addBot('📹 Video wird analysiert... Ich extrahiere einen Frame zur Analyse.');
      const video = document.createElement('video');
      video.src = URL.createObjectURL(f);
      video.onloadeddata = function() {
        video.currentTime = 1; // Frame bei 1 Sekunde
      };
      video.onseeked = function() {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        const dataUrl = canvas.toDataURL('image/jpeg', 0.8);
        state.pendingImg = dataUrl.split(',')[1];
        document.getElementById('pe-pimg').src = dataUrl;
        document.getElementById('pe-pname').textContent = '🎬 ' + f.name + ' (Frame extrahiert)';
        prev.style.display = 'flex';
        URL.revokeObjectURL(video.src);
      };
      return;
    }

    // Bild: direkt laden
    const reader = new FileReader();
    reader.onload = ev => {
      const url = ev.target.result;
      state.pendingImg = url.split(',')[1];
      document.getElementById('pe-pimg').src = url;
      document.getElementById('pe-pname').textContent = f.name;
      prev.style.display = 'flex';
    };
    reader.readAsDataURL(f);
  }

  // ===== CHECKOUT =====
  function showCheckout(service, auto) {
    const s = SERVICES[service];
    const icons = {diagnose:'✅',fernwartung:'🔧',vorort:'🚗'};
    const descs = {
      diagnose: auto
        ? 'Keine Rückmeldung erhalten — Abrechnung wird gemäß AGB ausgeführt. Service gilt als erfolgreich erbracht.'
        : 'Ihr Problem wurde erfolgreich gelöst. Servicebericht & Rechnung kommen per E-Mail.',
      fernwartung: 'Erweiterte Problemlösung durch unseren Techniker. Pauschal — egal wie komplex.',
      vorort: 'Vor-Ort Einsatz — Anfrage wird bearbeitet. Wir melden uns innerhalb von 24h.'
    };
    document.getElementById('pe-micon').textContent = icons[service]||'✅';
    document.getElementById('pe-mtitle').textContent = auto ? 'Automatische Abrechnung' : 'Problem gelöst!';
    document.getElementById('pe-mdesc').textContent = descs[service]||'';
    document.getElementById('pe-mprice').innerHTML = `${s.price} <small>pauschal inkl. MwSt.</small>`;
    document.getElementById('pe-mnote').textContent = 'Rechnung via Billbee · Servicebericht per E-Mail';

    // Kundendaten vorausfüllen
    if (state.customer.email) {
      document.getElementById('pe-m-email').value = state.customer.email;
      document.getElementById('pe-m-name').value = (state.customer.firstName||'') + ' ' + (state.customer.lastName||'');
    }

    document.getElementById('pe-mpaybtn').onclick = () => goCheckout(service);
    document.getElementById('pe-modal').classList.add('show');
  }

  function goCheckout(service) {
    const s = SERVICES[service];
    const email = document.getElementById('pe-m-email').value.trim();
    const name  = document.getElementById('pe-m-name').value.trim();

    if (!email || !validateEmail(email)) {
      document.getElementById('pe-m-email').style.borderColor = '#dc2626';
      return;
    }

    // Bericht generieren
    const reportData = generateReport(service, email, name);

    // Shopify Checkout mit Billbee-kompatiblen Order Notes
    const problem = state.history.filter(h=>h.role==='user').map(h=>h.content).join(' | ').substring(0,300);
    const loesung = state.history.filter(h=>h.role==='assistant').map(h=>h.content).join(' | ').substring(0,400);
    const now = new Date();

    // Order Note für Billbee (strukturiert)
    const billbeeNote = [
      'PE SERVICEBERICHT',
      'Ticket: ' + state.ticketNr,
      'Techniker: ' + TECH.name + ' (' + TECH.kuerzel + ')',
      'Datum: ' + now.toLocaleDateString('de-DE') + ' ' + now.toLocaleTimeString('de-DE'),
      'Service: ' + s.name,
      'Standort: ' + city,
      'Kunde: ' + state.customer.firstName + ' ' + state.customer.lastName,
      'Adresse: ' + state.customer.street + ', ' + state.customer.plz + ' ' + state.customer.city,
      'Tel: ' + state.customer.phone,
      state.customer.company ? 'Firma: ' + state.customer.company : '',
      '---PROBLEM---',
      problem,
      '---LOESUNG---',
      loesung,
      '---STATUS: ERFOLGREICH GELOEST---'
    ].filter(Boolean).join('\n');

    // URL-Parameter für Shopify Checkout (Billbee liest Order Notes aus)
    const params = new URLSearchParams({
      'checkout[email]': email,
      'note': billbeeNote,
      'attributes[pe_ticket]': state.ticketNr,
      'attributes[pe_techniker]': TECH.name,
      'attributes[pe_service]': s.name,
      'attributes[pe_datum]': now.toLocaleDateString('de-DE'),
      'attributes[pe_kunde_name]': name,
      'attributes[pe_kunde_email]': email,
      'attributes[pe_kunde_adresse]': state.customer.street + ', ' + state.customer.plz + ' ' + state.customer.city,
      'attributes[pe_billbee]': 'true'
    });

    // Report + Rechnung per SMTP versenden
    fetch('http://localhost:5700/send-report', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        email: email,
        name: name,
        ticketNr: state.ticketNr,
        service: s.name,
        price: s.price,
        reportHTML: reportData,
        billbeeNote: billbeeNote,
        sysinfo: state.sysinfo || {},
        messages: state.history,
        customer: state.customer,
        techName: TECH.name
      })
    }).then(r => r.json())
      .then(d => console.log('[PE] Report gesendet:', d))
      .catch(e => console.log('[PE] Report Fehler:', e));

    // Ticket als geloest markieren
    fetch('http://localhost:5700/ticket/save', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        ticketNr: state.ticketNr, email: email,
        sysinfo: state.sysinfo || {}, messages: state.history,
        status: 'solved', typ: service,
        resolution: state.history.filter(h=>h.role==='assistant').slice(-1)[0]?.content || ''
      })
    }).catch(e => {});

    addMsg('pe-sys', `✅ Ticket ${state.ticketNr} · Report & Rechnung werden an ${email} gesendet...`);
    document.getElementById('pe-modal').classList.remove('show');

    setTimeout(() => {
      window.location.href = 'https://www.premium-electronics.eu' + s.url + '?' + params.toString();
    }, 1500);
  }

  // ===== BERICHT GENERIEREN =====
  function generateReport(service, email, name) {
    const s = SERVICES[service];
    const now = new Date();
    const datum = now.toLocaleDateString('de-DE',{day:'2-digit',month:'2-digit',year:'numeric'});
    const uhrzeit = now.toLocaleTimeString('de-DE',{hour:'2-digit',minute:'2-digit'});
    const problem = state.history.filter(h=>h.role==='user').map(h=>h.content).join('\n').substring(0,500);
    const loesung = state.history.filter(h=>h.role==='assistant').map(h=>h.content).join('\n').substring(0,800);

    const reportHTML = `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8">
<title>PE Servicebericht ${state.ticketNr}</title>
<style>body{font-family:Arial,sans-serif;max-width:700px;margin:40px auto;color:#1a1a2e;padding:20px}
.header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;padding-bottom:16px;border-bottom:2px solid #2563eb}
.logo{font-size:18px;font-weight:900;color:#1e3a5f}.sub{font-size:11px;color:#666;margin-top:3px}
.ticket{font-size:11px;color:#666;text-align:right}.ticket strong{display:block;font-size:16px;color:#1e3a5f}
h2{font-size:14px;color:#1e3a5f;border-bottom:1px solid #e2e8f0;padding-bottom:6px;margin:20px 0 12px}
.row{display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f1f5f9;font-size:13px}
.label{color:#666;font-weight:600;min-width:140px}.value{color:#1a1a2e}
.box{background:#f8fafc;border-left:3px solid #2563eb;padding:12px 14px;margin:12px 0;font-size:13px;line-height:1.7;white-space:pre-wrap}
.success{background:#f0fdf4;border:2px solid #86efac;border-radius:8px;padding:14px;text-align:center;font-weight:700;color:#15803d;margin:20px 0}
.footer{margin-top:28px;font-size:10px;color:#999;text-align:center;border-top:1px solid #e2e8f0;padding-top:14px}
.sysinfo-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:12px 0}
.sysinfo-card{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:12px;text-align:center}
.sysinfo-card .icon{font-size:24px;margin-bottom:6px}
.sysinfo-card .label{font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:1px}
.sysinfo-card .value{font-size:13px;font-weight:700;color:#1e3a5f;margin-top:4px}
.timeline{margin:12px 0}
.tl-item{display:flex;gap:12px;padding:8px 0;border-bottom:1px solid #f1f5f9;align-items:flex-start}
.tl-dot{width:10px;height:10px;border-radius:50%;background:#2563eb;margin-top:4px;flex-shrink:0}
.tl-dot.green{background:#16a34a}
.tl-dot.amber{background:#d97706}
.tl-content{font-size:12px;color:#374151;line-height:1.5}
.tl-role{font-size:10px;color:#94a3b8;font-weight:700;margin-bottom:2px}
.prio-badge{display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700}
.prio-normal{background:#dbeafe;color:#1d4ed8}
.prio-high{background:#fef3c7;color:#d97706}
.prio-critical{background:#fee2e2;color:#dc2626}
.chat-transcript{background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:16px;max-height:400px;overflow-y:auto}
.msg-user{background:#dbeafe;border-radius:8px;padding:8px 12px;margin:6px 0;font-size:12px}
.msg-bot{background:#f0fdf4;border-radius:8px;padding:8px 12px;margin:6px 0;font-size:12px}
.msg-label{font-size:10px;color:#94a3b8;margin-bottom:3px;font-weight:700}
</style></head><body>
<div class="header">
  <div style="display:flex;align-items:center;gap:12px">
    <img src="https://cdn.shopify.com/s/files/1/0939/2927/5719/t/13/assets/pedigitalnetworks_transp_sw.png" alt="PE Digital Networks" style="height:40px;width:auto">
    <div>
      <div class="logo">PE Digital.Networks</div>
      <div class="sub">IT-Service & Cloud-Telefonie · 24/7/365</div>
    </div>
  </div>
  <div class="ticket">
    <span>Ticket-Nr.</span>
    <strong>${state.ticketNr}</strong>
    <div style="font-size:10px;color:#94a3b8;margin-top:4px">premium-electronics.eu</div>
  </div>
</div>
<div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:8px;padding:12px 16px;margin-bottom:16px;font-size:12px;display:flex;justify-content:space-between;flex-wrap:wrap;gap:8px">
  <span>📞 +49 375 79 139 149</span>
  <span>✉️ info@premium-electronics.eu</span>
  <span>🌐 www.premium-electronics.eu</span>
  <span>📍 Leipziger Str. 133, 08058 Zwickau</span>
</div>
<h2>Servicedaten</h2>
<div class="row"><span class="label">Techniker</span><span class="value">${TECH.name}</span></div>
<div class="row"><span class="label">Datum</span><span class="value">${datum} · ${uhrzeit} Uhr</span></div>
<div class="row"><span class="label">Standort</span><span class="value">${city}</span></div>
<div class="row"><span class="label">Service</span><span class="value">${s.name}</span></div>
<div class="row"><span class="label">Preis</span><span class="value">${s.price} pauschal inkl. MwSt.</span></div>
<div class="row"><span class="label">Status</span><span class="value" style="color:#16a34a;font-weight:700">✓ Erfolgreich gelöst</span></div>
<h2>Systeminfo</h2>
<div class="sysinfo-grid">
  <div class="sysinfo-card">
    <div class="icon">🖥️</div>
    <div class="label">Betriebssystem</div>
    <div class="value">${(state.sysinfo&&state.sysinfo.os)||'k.A.'}</div>
  </div>
  <div class="sysinfo-card">
    <div class="icon">💻</div>
    <div class="label">Gerät</div>
    <div class="value">${(state.sysinfo&&state.sysinfo.device)||'k.A.'}</div>
  </div>
  <div class="sysinfo-card">
    <div class="icon">⚙️</div>
    <div class="label">Programm</div>
    <div class="value">${(state.sysinfo&&state.sysinfo.prog)||'k.A.'}</div>
  </div>
  <div class="sysinfo-card">
    <div class="icon">🚨</div>
    <div class="label">Dringlichkeit</div>
    <div class="value"><span class="prio-badge prio-${(state.sysinfo&&state.sysinfo.prio)||'normal'}">${(state.sysinfo&&state.sysinfo.prio==='critical'?'Kritisch':state.sysinfo&&state.sysinfo.prio==='high'?'Hoch':'Normal')||'Normal'}</span></div>
  </div>
</div>
${state.sysinfo&&state.sysinfo.errorMsg?`<div class="row"><span class="label">Fehlermeldung</span><span class="value" style="color:#dc2626;font-family:monospace;font-size:12px">${state.sysinfo.errorMsg}</span></div>`:''}
${state.sysinfo&&state.sysinfo.lastchange?`<div class="row"><span class="label">Letzte Änderung</span><span class="value">${state.sysinfo.lastchange}</span></div>`:''}
${state.sysinfo&&state.sysinfo.tried?`<div class="row"><span class="label">Bereits versucht</span><span class="value">${state.sysinfo.tried}</span></div>`:''}
<h2>Kundendaten</h2>
<div class="row"><span class="label">Name</span><span class="value">${state.customer.firstName} ${state.customer.lastName}</span></div>
${state.customer.company ? `<div class="row"><span class="label">Firma</span><span class="value">${state.customer.company}</span></div>` : ''}
<div class="row"><span class="label">Adresse</span><span class="value">${state.customer.street}, ${state.customer.plz} ${state.customer.city}</span></div>
<div class="row"><span class="label">Telefon</span><span class="value">${state.customer.phone}</span></div>
<div class="row"><span class="label">E-Mail</span><span class="value">${email}</span></div>
<h2>Problembeschreibung</h2>
<div class="box">${problem||'Keine Details'}</div>
<h2>Durchgeführte Lösung</h2>
<div class="box">${loesung||'Keine Details'}</div>
<div class="success">✅ Problem erfolgreich gelöst · ${s.price} pauschal</div>
<h2>Support-Verlauf</h2>
<div class="chat-transcript">
${state.history.filter(h=>h.role!=='system'&&!h.content.startsWith('[SYSTEMINFO]')).slice(0,20).map(h=>`
  <div>
    <div class="msg-label">${h.role==='user'?'👤 Kunde':'🔧 '+TECH.name}</div>
    <div class="${h.role==='user'?'msg-user':'msg-bot'}">${h.content.substring(0,300)}${h.content.length>300?'...':''}</div>
  </div>`).join('')}
</div>
<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:16px;margin:16px 0">
  <div style="font-size:13px;font-weight:700;color:#1e3a5f;margin-bottom:12px">🛒 Passende Produkte für Sie</div>
  <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">
    <a href="https://www.premium-electronics.eu/collections/software" style="display:block;background:#fff;border:1px solid #e2e8f0;border-radius:6px;padding:10px;text-decoration:none;color:#1a1a2e">
      <div style="font-size:16px">💿</div>
      <div style="font-size:12px;font-weight:700;margin-top:4px">Microsoft Software</div>
      <div style="font-size:11px;color:#64748b">Windows & Office ESD</div>
    </a>
    <a href="https://www.premium-electronics.eu/collections/cloud-telefonanlage" style="display:block;background:#fff;border:1px solid #e2e8f0;border-radius:6px;padding:10px;text-decoration:none;color:#1a1a2e">
      <div style="font-size:16px">☎️</div>
      <div style="font-size:12px;font-weight:700;margin-top:4px">Cloud-Telefonanlage</div>
      <div style="font-size:11px;color:#64748b">ab 4,90€/Nutzer/Monat</div>
    </a>
    <a href="https://www.premium-electronics.eu/collections/ki-software-aktivierungen" style="display:block;background:#fff;border:1px solid #e2e8f0;border-radius:6px;padding:10px;text-decoration:none;color:#1a1a2e">
      <div style="font-size:16px">🤖</div>
      <div style="font-size:12px;font-weight:700;margin-top:4px">KI-Tools</div>
      <div style="font-size:11px;color:#64748b">ChatGPT, Claude & mehr</div>
    </a>
    <a href="https://www.premium-electronics.eu/pages/it-service-pc-notdienst-de" style="display:block;background:#fff;border:1px solid #e2e8f0;border-radius:6px;padding:10px;text-decoration:none;color:#1a1a2e">
      <div style="font-size:16px">🔧</div>
      <div style="font-size:12px;font-weight:700;margin-top:4px">IT-Notdienst buchen</div>
      <div style="font-size:11px;color:#64748b">Kein Erfolg = kein Geld</div>
    </a>
  </div>
</div>
<div class="footer">PE Digital Networks · premium-electronics.eu · +49 375 79 139 149<br>
Rechnung wird über Billbee.io erstellt und an Ihre E-Mail zugestellt · Ticket: ${state.ticketNr}<br>
<strong style="color:#2563eb">★★★★★ 214 Bewertungen · Seit 2013 Ihr IT-Partner</strong></div>
</body></html>`;

    // Download
    try {
      const blob = new Blob([reportHTML],{type:'text/html'});
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href=url; a.download=`PE-Servicebericht-${state.ticketNr}.html`;
      document.body.appendChild(a); a.click();
      setTimeout(()=>{URL.revokeObjectURL(url);a.remove();},1000);
    } catch(e) {}

    // sessionStorage für Dankeseite
    try {
      sessionStorage.setItem('pe_report_html', reportHTML);
      sessionStorage.setItem('pe_report_ticket', state.ticketNr);
      sessionStorage.setItem('pe_report_email', email);
    } catch(e) {}

    return reportHTML;
  }

  // ===== ESKALATION AN FACHABTEILUNG =====
  function triggerEscalation(grund) {
    if (state.escalated) return;
    state.escalated = true;
    if (state.autoChargeTimer) { clearInterval(state.autoChargeTimer); autoTimer.classList.remove('show'); }

    // Gesprächsverlauf aufbereiten
    const now = new Date();
    const datum = now.toLocaleDateString('de-DE',{day:'2-digit',month:'2-digit',year:'numeric'});
    const uhrzeit = now.toLocaleTimeString('de-DE',{hour:'2-digit',minute:'2-digit'});
    const verlauf = state.history.map(h =>
      (h.role==='user' ? '👤 KUNDE: ' : '🔧 TECHNIKER: ') + h.content
    ).join('\n\n');
    const problem = state.history.filter(h=>h.role==='user').map(h=>h.content).join(' | ').substring(0,300);

    // E-Mail an Fachabteilung via Shopify Contact Form
    try {
      const fd = new FormData();
      fd.append('form_type','contact');
      fd.append('utf8','✓');
      fd.append('contact[email]','info@premium-electronics.eu');
      fd.append('contact[name]','PE ESKALATION — ' + state.ticketNr);
      fd.append('contact[body]',
        '🚨 ESKALATION AN FACHABTEILUNG\n' +
        '================================\n' +
        'Ticket: ' + state.ticketNr + '\n' +
        'Datum: ' + datum + ' · ' + uhrzeit + '\n' +
        'Techniker: ' + TECH.name + '\n' +
        'Eskalationsgrund: ' + (grund || 'Nicht lösbar') + '\n\n' +
        'KUNDENDATEN:\n' +
        'Name: ' + (state.customer.firstName||'') + ' ' + (state.customer.lastName||'') + '\n' +
        (state.customer.company ? 'Firma: ' + state.customer.company + '\n' : '') +
        'Adresse: ' + (state.customer.street||'') + ', ' + (state.customer.plz||'') + ' ' + (state.customer.city||'') + '\n' +
        'Tel: ' + (state.customer.phone||'') + '\n' +
        'E-Mail: ' + (state.customer.email||'') + '\n\n' +
        'PROBLEM:\n' + problem + '\n\n' +
        'VOLLSTÄNDIGER GESPRÄCHSVERLAUF:\n' +
        '--------------------------------\n' +
        verlauf + '\n\n' +
        'SERVICE: ' + SERVICES[state.service].name + '\n' +
        'STATUS: Eskaliert — Kundenrückmeldung erforderlich\n' +
        '================================'
      );
      fetch(SHOP + '/contact', { method:'POST', body:fd });
    } catch(e) { console.log('Eskalation Fehler:', e); }

    // Kunden-Info im Chat
    setTimeout(() => {
      addMsg('pe-sys',
        '📋 Ihr Anliegen wurde an unsere Fachabteilung weitergeleitet.\n' +
        'Ticket-Nr.: <strong>' + state.ticketNr + '</strong>\n' +
        'Sie erhalten innerhalb von <strong>1–2 Werktagen</strong> eine persönliche Rückmeldung an ' +
        '<strong>' + (state.customer.email||'Ihre E-Mail') + '</strong>.'
      );

      // Eskalations-Button ausblenden, Kontakt-Info zeigen
      addMsg('pe-bot',
        'Ich habe alle Details Ihres Falls vollständig an unsere Fachabteilung übergeben — ' +
        'inklusive unserem gesamten Gesprächsverlauf und dem Servicebericht.<br><br>' +
        'Sie werden sich persönlich bei Ihnen melden. ' +
        'Bei dringenden Fragen erreichen Sie uns auch direkt unter:<br>' +
        '<strong>📧 info@premium-electronics.eu</strong><br>' +
        '<strong>🌐 premium-electronics.eu/pages/contact</strong>'
      );
    }, 400);
  }

  // ===== PUBLIC API =====
  window.PESupport = {
    clearFile: () => {
      state.pendingImg=null; file.value=''; prev.style.display='none';
    },
    solved: (auto=false) => {
      if (state.autoChargeTimer) { clearInterval(state.autoChargeTimer); autoTimer.classList.remove('show'); }
      showCheckout(state.service, auto);
    },
    escalate: () => {
      state.service = 'fernwartung';
      if (state.autoChargeTimer) { clearInterval(state.autoChargeTimer); autoTimer.classList.remove('show'); }
      showCheckout('fernwartung', false);
    }
  };



  // ═══ VISION: PDF-Bericht & Annotierung im Browser ═══

  window.peGeneratePDF = function() {
    const analysis = state.pendingVisionAnalysis;
    const ticket = state.ticketNr;

    // Hole alle Bot-Nachrichten aus dem Chat-Verlauf
    const chatText = state.history
      .map(h => (h.role === 'assistant' ? '🔧 Techniker: ' : '👤 Kunde: ') + h.content)
      .join('\n\n');

    // HTML-Report als neue Seite öffnen (druckfähig)
    const customer = state.customer;
    const html = `<!DOCTYPE html>
<html lang="de">
<head>
<meta charset="UTF-8">
<title>PE Servicebericht ${ticket}</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: 'Segoe UI',Arial,sans-serif; color:#1e293b; background:#f8fafc; }
  .header { background:#0f172a; color:#fff; padding:20px 30px; display:flex; justify-content:space-between; align-items:center; }
  .header h1 { font-size:18px; font-weight:700; }
  .header .ticket { background:#2563eb; color:#fff; padding:5px 14px; border-radius:20px; font-size:13px; font-weight:600; }
  .body { max-width:800px; margin:20px auto; padding:0 20px; }
  .section { background:#fff; border:1px solid #e2e8f0; border-radius:10px; padding:20px; margin-bottom:16px; }
  .section-title { font-size:13px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.5px; margin-bottom:12px; padding-bottom:8px; border-bottom:2px solid #e2e8f0; }
  .grid { display:grid; grid-template-columns:1fr 1fr; gap:10px; }
  .field label { font-size:11px; font-weight:600; color:#94a3b8; text-transform:uppercase; }
  .field value { font-size:13px; color:#1e293b; font-weight:500; display:block; margin-top:2px; }
  .chat { font-size:12px; line-height:1.8; color:#475569; white-space:pre-wrap; max-height:400px; overflow-y:auto; background:#f8fafc; border-radius:6px; padding:12px; }
  .footer { text-align:center; font-size:11px; color:#94a3b8; padding:20px; border-top:1px solid #e2e8f0; margin-top:20px; }
  .badge { display:inline-block; padding:3px 10px; border-radius:20px; font-size:11px; font-weight:700; }
  .badge-hoch { background:#fee2e2; color:#dc2626; }
  .badge-mittel { background:#fef3c7; color:#d97706; }
  .badge-niedrig { background:#d1fae5; color:#059669; }
  @media print { body{background:#fff} .no-print{display:none} }
</style>
</head>
<body>
<div class="header">
  <div>
    <h1>PE Digital Networks — IT-Servicebericht</h1>
    <div style="font-size:12px;color:#94a3b8;margin-top:3px;">Powered by Claude AI Vision | Automatische Diagnose</div>
  </div>
  <div class="ticket">Ticket: ${ticket}</div>
</div>
<div class="body">
  <div class="section">
    <div class="section-title">Diagnose-Übersicht</div>
    <div class="grid">
      <div class="field"><label>Kunde</label><value>${customer.firstName} ${customer.lastName}</value></div>
      <div class="field"><label>Ort</label><value>${customer.city || 'nicht angegeben'}</value></div>
      <div class="field"><label>E-Mail</label><value>${customer.email || '-'}</value></div>
      <div class="field"><label>Datum</label><value>${new Date().toLocaleDateString('de-DE', {day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}</value></div>
      <div class="field"><label>Service</label><value>KI-Diagnose (29,90€)</value></div>
      <div class="field"><label>Status</label><value>In Bearbeitung</value></div>
    </div>
  </div>
  <div class="section">
    <div class="section-title">Gesprächsverlauf & Diagnose</div>
    <div class="chat">${chatText.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
  </div>
  <div class="section" style="border-color:#bbf7d0;background:#f0fdf4;">
    <div class="section-title" style="color:#16a34a;">Servicebedingungen</div>
    <p style="font-size:12px;color:#15803d;line-height:1.7;">
      ✅ <strong>Kein Erfolg = Kein Geld</strong> — Sie zahlen ausschließlich bei erfolgreicher Lösung.<br>
      Diagnose-Pauschalpreis: <strong>29,90€ inkl. MwSt.</strong><br>
      Falls Fernwartung benötigt: <strong>69,90€ pauschal</strong>
    </p>
  </div>
</div>
<div class="footer">
  PE Digital Networks | powered by Softwareunion | info@premium-electronics.eu<br>
  Dieser Bericht wurde automatisch durch Claude AI Vision erstellt.
</div>
<script>setTimeout(()=>window.print(),500);</script>
</body>
</html>`;

    const w = window.open('', '_blank', 'width=900,height=700');
    if (w) {
      w.document.write(html);
      w.document.close();
    }
  };

  window.peShowAnnotated = function() {
    if (!state.pendingImg) {
      addMsg('pe-sys', 'Kein Screenshot verfügbar. Bitte laden Sie einen Screenshot hoch.');
      return;
    }
    // Zeige das Originalbild mit Overlay-Nummern direkt im Chat
    const imgDiv = document.createElement('div');
    imgDiv.style.cssText = 'position:relative;display:inline-block;max-width:100%;margin:8px 0;';
    imgDiv.innerHTML = `
      <img src="\${state.lastImageSrc || ''}" style="max-width:100%;border-radius:8px;border:2px solid #2563eb;" alt="Screenshot">
      <div style="position:absolute;top:8px;left:8px;background:rgba(15,23,42,.85);color:#fff;font-size:11px;font-weight:700;padding:4px 10px;border-radius:5px;">
        📷 Analysierter Screenshot
      </div>
    `;
    const msgEl = document.createElement('div');
    msgEl.className = 'pe-msg pe-msg--bot';
    msgEl.appendChild(imgDiv);
    document.getElementById('pe-phase-chat').appendChild(msgEl);
    document.getElementById('pe-phase-chat').scrollTop = 99999;
  };

  // Beim File-Upload: Bild-Src für späteren Gebrauch speichern
  const _origClearFile = window.PESupport ? window.PESupport.clearFile : null;


})();
